window.onload = function() {
  document.documentElement.classList.remove('initializing');

  initCanvas();
  initGrain();
  requestAnimationFrame(loop);
}

document.addEventListener('DOMContentLoaded', function() {
  initVideo();
});